import { render, staticRenderFns } from "./SystemPermissionManage.vue?vue&type=template&id=6ff165d1"
import script from "./SystemPermissionManage.vue?vue&type=script&lang=js"
export * from "./SystemPermissionManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports